import { z } from 'zod'

export const FallbackBehaviourType = {
  black: 'black',
  image: 'image',
  test: 'test',
} as const

export const fallbackBehaviourTypeSchema = z.nativeEnum(FallbackBehaviourType)
export type FallbackBehaviourType = z.infer<typeof fallbackBehaviourTypeSchema>

export const blackFallbackBehaviour = z.object({
  type: z.literal(FallbackBehaviourType.black),
})

export const imageFallbackBehaviour = z.object({
  type: z.literal(FallbackBehaviourType.image),
  imageUrl: z.string().url(),
})

export const testFallbackBehaviour = z.object({
  type: z.literal(FallbackBehaviourType.test),
  videoTestType: z.string(),
  audioTestType: z.string(),
})

export const fallbackBehaviourSchema = z.discriminatedUnion('type', [
  blackFallbackBehaviour,
  imageFallbackBehaviour,
  testFallbackBehaviour,
])
export type FallbackBehaviour = z.infer<typeof fallbackBehaviourSchema>
